import { COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS } from '@core/components/component-factory/component-factory-config-input.registry';
import type { ConfigComponentContract } from '@shared/utils/content-builder/config-component-contract';
import { computedResolvedConfig } from '@shared/utils/content-builder/block-config-computed-resolver';
import type { HeaderAnchorListBlockConfig } from '@front-platform/content-builder';
import { headerAnchorListBlockResolveConfig } from '@front-platform/content-builder';
import { Component, input } from '@angular/core';

import { AnchorStoreSelector } from '@common/selectors/anchor.selector';
export interface HeaderAnchorListBlockRuntimeConfig {}

export type HeaderAnchorListBlockConfigInput = Partial<
  Omit<HeaderAnchorListBlockConfig, keyof HeaderAnchorListBlockRuntimeConfig> &
    HeaderAnchorListBlockRuntimeConfig
>;
export type HeaderAnchorListBlockResolvedConfig = Omit<
  HeaderAnchorListBlockConfig,
  keyof HeaderAnchorListBlockRuntimeConfig
> &
  Partial<HeaderAnchorListBlockRuntimeConfig>;
export interface HeaderAnchorListBlockContract extends ConfigComponentContract<
  HeaderAnchorListBlockConfigInput,
  HeaderAnchorListBlockResolvedConfig
> {}

@Component({
  selector: 'app-header-anchor-list-block',
  templateUrl: './header-anchor-list-block.component.html',
  standalone: false,
})
export class HeaderAnchorListBlockComponent implements HeaderAnchorListBlockContract {
  readonly config = input<HeaderAnchorListBlockConfigInput>({});
  readonly resolvedConfig = computedResolvedConfig<
    HeaderAnchorListBlockConfig,
    HeaderAnchorListBlockRuntimeConfig
  >(headerAnchorListBlockResolveConfig, () => ({ config: this.config() }));
  anchors$ = this.anchorSelector.selectAnchors;
  constructor(private anchorSelector: AnchorStoreSelector) {}
}
COMPONENT_FACTORY_CONFIG_INPUT_COMPONENTS.set(HeaderAnchorListBlockComponent, { 'keyAliases': {} });
